export type TagType = "后续" | "反转" | "回应" | "新进展";

export interface FeedItem {
  id: string;
  tag: TagType;
  title: string;
  timeLabel: string;
  summary: string;
  views: string;
  likes: number;
}

export const navItems = [
  { key: "top", label: "首页" },
  { key: "feed", label: "最新动态" },
  { key: "reversal", label: "反转精选" },
  { key: "timeline", label: "完整时间线" },
  { key: "responses", label: "各方回应" },
  { key: "tracking", label: "正在追踪" },
  { key: "about", label: "关于本站" },
];

export const feedFilters: Array<"全部" | TagType> = ["全部", "后续", "反转", "回应", "新进展"];

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    tag: "后续",
    title: "“拾光甄选”助农专场后续：补发订单连夜发货，售后通道已扩容",
    timeLabel: "今天 09:40",
    summary: "继此前被指夸大助农产地后，团队连夜建立补发与退款专线，称将在一周内完成全部问题订单核验，并公布客服扩容方案。",
    views: "128.6万",
    likes: 18420,
  },
  {
    id: "f2",
    tag: "反转",
    title: "质检报告反转实锤：送检样品与直播间宣传批次一致",
    timeLabel: "昨天 22:15",
    summary: "此前流传“样品被调包”的说法出现反转，第三方机构公布送检封条全程留痕记录，主播团队凌晨发文称将整理完整链路供公众核验。",
    views: "306.2万",
    likes: 45210,
  },
  {
    id: "f3",
    tag: "回应",
    title: "品牌方首度回应：对质量争议致歉，但否认“故意压货”指控",
    timeLabel: "昨天 18:02",
    summary: "涉事品牌方发声明，承认品控流程存在漏洞，同时晒出供货合同澄清压货与倒卖传闻，并承诺成立独立小组复查。",
    views: "214.9万",
    likes: 27880,
  },
  {
    id: "f4",
    tag: "新进展",
    title: "平台介入调查：临时冻结争议佣金，要求 48 小时内提交完整凭证",
    timeLabel: "昨天 11:26",
    summary: "电商平台更新处理进度，称已冻结本场争议佣金，并组建专项小组，若凭证齐全将于本周内给出阶段结论。",
    views: "98.7万",
    likes: 12130,
  },
  {
    id: "f5",
    tag: "后续",
    title: "打假博主追加爆料：指向同一条供应链存在两套包装体系",
    timeLabel: "前天 21:50",
    summary: "打假博主晒出产地照片与装箱记录，认为两套包装体系或为“专供”与“商超”混卖，目前样本已再次送检。",
    views: "251.4万",
    likes: 33850,
  },
  {
    id: "f6",
    tag: "回应",
    title: "主播本人回应“退居幕后”传闻：将暂停 30 天直播自查选品",
    timeLabel: "前天 16:33",
    summary: "主播林晚舟在个人主页表态，称暂别直播间一个月完成内部选品流程梳理，期间由团队主播轮值出镜。",
    views: "402.8万",
    likes: 56100,
  },
  {
    id: "f7",
    tag: "反转",
    title: "“倒卖内幕”出现反转：网传聊天截图被指系早期谣言样本",
    timeLabel: "前天 09:12",
    summary: "关于核心团队倒卖货源的聊天记录，经比对被指剪辑拼接，疑似为旧谣言模板二次传播，警方暂未予立案。",
    views: "186.3万",
    likes: 20460,
  },
  {
    id: "f8",
    tag: "新进展",
    title: "消费者集体反馈平台：三千余人登记等待产地凭证公开",
    timeLabel: "3 天前",
    summary: "越来越多下单用户加入联合反馈，普遍诉求集中在“公开产地视频凭证”与“七日内无理由退货权益”两项。",
    views: "77.5万",
    likes: 9930,
  },
];

export interface ReversalItem {
  id: string;
  stage: string;
  title: string;
  before: string;
  after: string;
  verdict: string;
}

export const reversalItems: ReversalItem[] = [
  {
    id: "r1",
    stage: "第 2 幕 · 反转成立",
    title: "“产地造假”到“批次存疑”：证据链在哪个环节断裂",
    before: "爆料称所售果品并非宣称产地，疑似外地调货贴牌，舆论一边倒质疑助农真实性。",
    after: "送检封条、货运单与采摘批次号陆续对齐，产地存疑范围从“全部造假”收窄为“单一批次标号缺失”。",
    verdict: "结论：夸大面积成立，全盘造假不成立，关键差异来自包装批次漏标而非源头替换。",
  },
  {
    id: "r2",
    stage: "第 3 幕 · 仍在反转",
    title: "“倒卖货源”聊天截图：是锤还是料？",
    before: "一段所谓内部对话流出，声称核心团队高价倒卖助农货源，激起第二轮声讨。",
    after: "多方指出截图时间戳与发布账号存在矛盾，疑似旧谣言素材被换头重发，原始样本已提交比对。",
    verdict: "结论：暂缓定性，等待原始文件核验；平台已要求上传完整录屏与后台日志。",
  },
  {
    id: "r3",
    stage: "第 1 幕 · 已下结论",
    title: "助农专场“超低价”真实存在，但优惠期被刻意压缩",
    before: "读者质疑所谓“专享价”其实一直都有，低价是话术而非让利。",
    after: "后台优惠记录公开后确认价格确实更低，但补贴期仅开放四十分钟，大量用户错过窗口。",
    verdict: "结论：低价属实，让利话术夸大，平台已补发优惠券作为补偿。",
  },
];

export interface TimelineEvent {
  id: string;
  date: string;
  day: string;
  phase: "发酵" | "追问" | "反转" | "回应" | "定论";
  title: string;
  body: string;
}

export const timelineEvents: TimelineEvent[] = [
  {
    id: "t1",
    date: "第 1 天",
    day: "D+0",
    phase: "发酵",
    title: "直播当晚，一位下单用户晒出开箱对比图",
    body: "助农专场结束后约三小时，有用户发现到货包装与直播展示产地不同，质疑声开始在评论区聚集，阅读迅速破万。",
  },
  {
    id: "t2",
    date: "第 2 天",
    day: "D+1",
    phase: "追问",
    title: "打假博主跟进，放出所谓“贴牌”证据",
    body: "第二日中午，打假博主称拍到疑似异地装车画面，暗示货品并非宣称呼称产地，相关词条登上热搜。",
  },
  {
    id: "t3",
    date: "第 3 天",
    day: "D+2",
    phase: "反转",
    title: "第三方送检结果公布，批次问题首次被厘清",
    body: "送检报告显示样品本身达标，争议集中于包装批次号缺失，产地“造假”传闻首次出现松动，舆论出现分裂。",
  },
  {
    id: "t4",
    date: "第 5 天",
    day: "D+4",
    phase: "反转",
    title: "“倒卖内幕”截图流出后又被指为旧料",
    body: "疑似内部倒卖聊天记录曝光引发二次声讨，随后被指时间戳矛盾、疑似剪辑，事件进入二轮拉锯。",
  },
  {
    id: "t5",
    date: "第 6 天",
    day: "D+5",
    phase: "回应",
    title: "品牌方发声明致歉并晒出供货合同",
    body: "品牌方承认品控漏洞、对消费者致歉，同时否认压货倒卖，晒出完整供货链路，并宣布成立独立复查小组。",
  },
  {
    id: "t6",
    date: "第 7 天",
    day: "D+6",
    phase: "回应",
    title: "主播宣布暂停直播三十天自查选品",
    body: "林晚舟在个人主页发文，宣布暂别直播间，用一个月梳理选品与产地凭证流程，被舆论视为“软性切割”。",
  },
  {
    id: "t7",
    date: "第 8 天",
    day: "D+7",
    phase: "回应",
    title: "平台冻结佣金并组建专项小组",
    body: "电商平台更新进度：冻结争议佣金，要求 48 小时内提交完整凭证，本周内给出阶段结论，读者开始倒计时等待。",
  },
];

export const phaseMeta: Record<TimelineEvent["phase"], { dot: string; label: string }> = {
  发酵: { dot: "bg-accent-500", label: "text-accent-700" },
  追问: { dot: "bg-secondary-500", label: "text-secondary-700" },
  反转: { dot: "bg-primary-500", label: "text-primary-700" },
  回应: { dot: "bg-accent-500", label: "text-accent-700" },
  定论: { dot: "bg-foreground-800", label: "text-foreground-800" },
};

export interface ResponseItem {
  id: string;
  party: string;
  role: string;
  timeLabel: string;
  stance: string;
  quote: string;
  action: string;
}

export const responseItems: ResponseItem[] = [
  {
    id: "p1",
    party: "拾光文化 · 主播团队",
    role: "当事人",
    timeLabel: "昨天 22:40",
    stance: "诚恳致歉，暂停直播",
    quote: "“无论环节出在哪里，都说明我们把关不够，辜负了信任。我们决定暂停直播三十天，把选品和产地核验流程彻底重建。”",
    action: "补发订单 + 公示质检全程",
  },
  {
    id: "p2",
    party: "甄野果业 · 涉事品牌方",
    role: "供应商",
    timeLabel: "昨天 18:02",
    stance: "致歉并否认压货",
    quote: "“品控疏漏是我们的责任，但我们不存在故意压货或倒卖行为，完整供货合同与入库记录已一并公布。”",
    action: "成立独立品控复查小组",
  },
  {
    id: "p3",
    party: "橙鹿商城 · 电商平台",
    role: "平台方",
    timeLabel: "昨天 11:26",
    stance: "介入调查，冻结佣金",
    quote: "“已临时冻结本场争议佣金，专项小组将核对全部凭证，力争本周内给出可公开的阶段结论。”",
    action: "建立 48 小时凭证核验通道",
  },
  {
    id: "p4",
    party: "第三方质检机构",
    role: "送检方",
    timeLabel: "第 3 天",
    stance: "样品达标，批次存疑",
    quote: "“本次送检样品各项指标合格，争议集中于包装批次编号缺失，建议就完整销售批次补充抽样。”",
    action: "第二次补抽样已启动",
  },
];

export interface TrackingEvent {
  id: string;
  name: string;
  category: string;
  status: string;
  hot: string;
  lastUpdate: string;
}

export const trackingEvents: TrackingEvent[] = [
  { id: "e1", name: "拾光甄选助农专场风波", category: "直播带货", status: "进行中 · 等待阶段结论", hot: "热", lastUpdate: "9 小时前" },
  { id: "e2", name: "某数码博主“翻新机”争议", category: "3C 消费", status: "跟进中 · 二次回应", hot: "热", lastUpdate: "昨天" },
  { id: "e3", name: "连锁餐饮“预制菜”标注事件", category: "餐饮", status: "已下阶段性结论", hot: "温", lastUpdate: "3 天前" },
  { id: "e4", name: "明星工作室“澄清函”罗生门", category: "娱乐", status: "停滞 · 等待新料", hot: "温", lastUpdate: "5 天前" },
  { id: "e5", name: "教育机构“保过”宣传争议", category: "教育", status: "监督整改中", hot: "新", lastUpdate: "昨天" },
  { id: "e6", name: "美妆“成分表造假”风波", category: "美妆", status: "检验中 · 即将更新", hot: "热", lastUpdate: "6 小时前" },
  { id: "e7", name: "旅游团“低价团费”套路爆料", category: "旅游", status: "多平台跟进", hot: "温", lastUpdate: "2 天前" },
  { id: "e8", name: "宠物粮“产地混标”事件", category: "宠物", status: "已完成时间线整理", hot: "新", lastUpdate: "1 天前" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "52爆料是什么？",
    a: "52爆料是一个持续追踪公共事件后续与反转的中文内容站，把碎片化的爆料、回应和时间线整理成可连续追读的栏目，方便读者按顺序蹲更新。",
  },
  {
    q: "“后续不断更”是什么意思？",
    a: "指我们对已在追踪的事件，会在每有新进展、新回应或关键反转时及时补充更新时间线，而不是发完首篇就结束，读者可以持续跟进到事件收尾。",
  },
  {
    q: "内容来源可靠吗？",
    a: "我们只整理公开可见的官方声明、平台公告、机构报告与可核验素材，并标注每条进展的时点与性质；对存疑信息会标注“仍在核实”而不是直接下结论。",
  },
  {
    q: "时间线多久更新一次？",
    a: "以事件实际进展为准。重大节点（官方回应、反转证据、处理结果）会在核实后优先补充；日常小范围澄清则合并到阶段性小结里更新。",
  },
  {
    q: "如何标记我追的更新？",
    a: "在首页动态卡片上点击书签按钮即可收藏“想追的更新”，方便你回到本页快速定位自己关心的那一条进展。",
  },
  {
    q: "我可以投稿补充线索吗？",
    a: "欢迎通过页面底部的追更提醒表单留下关注的事件名与线索概要，我们会把它纳入候选追踪清单，并在核实后跟进。",
  },
];

export const stats = [
  { num: "38", unit: "个", label: "正在持续追踪的事件" },
  { num: "1200", unit: "+", label: "条已完成梳理的进展" },
  { num: "24", unit: "h", label: "重大节点平均更新时效" },
  { num: "92%", unit: "", label: "读者认为信息可读性高" },
];

export const heroImages = {
  cover:
    "https://readdy.ai/api/search-image?query=stylized%20editorial%20mystery%20illustration%20of%20a%20giant%20magnifying%20glass%20casting%20warm%20amber%20light%20over%20scattered%20newspaper%20clippings%20and%20torn%20timeline%20pages%20on%20deep%20charcoal%20background%2C%20cinematic%20coral%20and%20gold%20highlights%2C%20dramatic%20shadows%2C%20no%20text%2C%20high%20contrast&width=1600&height=980&seq=hero-cover-52&orientation=landscape",
  cardFollow:
    "https://readdy.ai/api/search-image?query=minimal%20editorial%20illustration%20of%20a%20stack%20of%20manila%20folders%20with%20a%20red%20forward%20arrow%20and%20small%20clock%2C%20warm%20cream%20background%2C%20flat%20vector%20art%20with%20soft%20shadows%2C%20coral%20and%20amber%20accents&width=640&height=480&seq=card-follow-52&orientation=landscape",
  cardFlip:
    "https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20an%20arrow%20reversing%20direction%20between%20two%20torn%20paper%20pages%2C%20amber%20and%20coral%20color%20palette%2C%20soft%20cream%20background%2C%20modern%20minimal&width=640&height=480&seq=card-flip-52&orientation=landscape",
  cardMic:
    "https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20person%20speaking%20at%20a%20small%20podium%20with%20concentric%20sound%20wave%20lines%2C%20warm%20coral%20and%20amber%20palette%2C%20soft%20cream%20background&width=640&height=480&seq=card-mic-52&orientation=landscape",
  reversalBig:
    "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20balance%20scale%20tilting%20between%20two%20stacks%20of%20evidence%20files%2C%20warm%20amber%20and%20coral%20lighting%2C%20cream%20and%20charcoal%20palette%2C%20flat%20vector%20with%20soft%20shadow%2C%20investigative%20drama%20mood&width=900&height=760&seq=reversal-big-52&orientation=portrait",
  about:
    "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20an%20open%20newspaper%20folded%20into%20an%20origami%20paper%20plane%20flying%20upward%2C%20warm%20cream%20background%2C%20amber%20and%20coral%20accents%2C%20flat%20vector%2C%20soft%20minimal&width=760&height=900&seq=about-52&orientation=portrait",
  subscribe:
    "https://readdy.ai/api/search-image?query=wide%20editorial%20illustration%20of%20an%20envelope%20with%20a%20small%20radar%20and%20signal%20waves%20rising%2C%20warm%20amber%20and%20coral%20gradient%20over%20deep%20charcoal%2C%20mystery%20update%20theme%2C%20no%20text&width=1400&height=640&seq=subscribe-52&orientation=landscape",
};